import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import _ from "lodash";
import { Button, useDataProvider } from "react-admin";
import { useFormState } from "react-final-form";
import { useState } from "react";

const useStyles = makeStyles({
  saveButton: {
    width: "100%",
    marginTop: 10,
    marginLeft: 0,
    borderRadius: 0,
    padding: 15,
    backgroundColor: "#E7E7E7",
    color: "#4E4E4E",
    fontWeight: 600,
    boxShadow: "unset",
    "&:hover": {
      backgroundColor: "#D8D8D8 !important",
    },
  },
});

const SaveManageStudentsButton = ({
  routeLocationData,
  handleClose,
  manageStudentCallback,
  routesData,
  selectedMarkers,
}: any) => {
  const classes = useStyles();
  const { values } = useFormState();
  const provider = useDataProvider();
  const newRouteLocation = _.clone(routeLocationData);

  const [isHaveDuplicateStudent, setIsHaveDuplicateStudent] =
    useState<boolean>(false);

  const handleOpenDialogDuplicateStudent = () => {
    setIsHaveDuplicateStudent(true);
  };

  const handleCloseDialogDuplicateStudent = () => {
    setIsHaveDuplicateStudent(false);
  };

  const handleSaveManageStudent = () => {
    getStudentsByIds().then((students) => {
      newRouteLocation.students = students;

      manageStudentCallback(newRouteLocation);
    });
  };

  const handleCheckDuplicateStudents = async () => {
    const existingStudentIds = new Set<number>();

    routesData.forEach((route: any) => {
      route.routeLocations.forEach((loc: any) => {
        if (loc.id !== routeLocationData.id) {
          if (Array.isArray(loc.students)) {
            loc.students.forEach((student: any) =>
              existingStudentIds.add(student.id),
            );
          }
        }
      });
    });

    selectedMarkers
      .filter(
        (selectedMarker: any) =>
          Number(selectedMarker.order) !== Number(routeLocationData.order),
      )
      .forEach((selectedMarker: any) => {
        if (Array.isArray(selectedMarker.students)) {
          selectedMarker.students.forEach((student: any) =>
            existingStudentIds.add(student.id),
          );
        }
      });

    const duplicatedIds = values.studentIds.filter((id: number) =>
      existingStudentIds.has(id),
    );

    if (duplicatedIds.length > 0) {
      handleOpenDialogDuplicateStudent();
    } else {
      handleSaveManageStudent();
      handleClose();
    }
  };

  const getStudentsByIds = async () => {
    return await provider
      .getMany("students", { ids: values.studentIds })
      .then((result) => {
        return result.data;
      });
  };

  return (
    <>
      <Button
        label="Save"
        className={classes.saveButton}
        onClick={handleCheckDuplicateStudents}
      />

      <Dialog
        open={isHaveDuplicateStudent}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Info Duplicate Student
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Some students on the list that you are trying to add has already
            been added to this wave. do you want to add the students again?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialogDuplicateStudent}
            color="secondary"
            label="Back"
          />
          <Button
            onClick={() => {
              handleSaveManageStudent();
              handleClose();
              handleCloseDialogDuplicateStudent();
            }}
            color="primary"
            label="Confirm"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SaveManageStudentsButton;
